import React from "react";
import { usePlayerAllTimeThrowScores } from "../util/db";

function AllTimeThrowScoreStats({ uid }) {
  const { data: throwScores, status, error } = usePlayerAllTimeThrowScores(uid);

  // Calculate throw score statistics
  const calculateThrowScoreStats = (scores) => {
    const throwScoreCounts = {
      0: 0, // 🚫 Miss
      1: 0, // ⛓️ Metal Hit
      2: 0, // ✔️ In Basket
    };

    if (!scores || !Array.isArray(scores)) {
      return throwScoreCounts;
    }

    scores.forEach((throwScore) => {
      if (
        throwScore.throw_score !== undefined &&
        throwScore.throw_score !== null
      ) {
        throwScoreCounts[throwScore.throw_score]++;
      }
    });

    return throwScoreCounts;
  };

  const stats = calculateThrowScoreStats(throwScores);
  const totalThrows = stats[0] + stats[1] + stats[2];

  // Calculate percentages
  const getPercentage = (count) => {
    if (totalThrows === 0) return 0;
    return ((count / totalThrows) * 100).toFixed(1);
  };

  if (status === "loading") {
    return <div>Loading throw statistics...</div>;
  }

  if (error) {
    return <div>Error loading throw statistics</div>;
  }

  if (totalThrows === 0) {
    return <div>No throw score data available</div>;
  }
  return (
    <div>
      <div style={{ fontSize: "14px" }}>
        {" "}
        <div
          className="d-flex justify-content-between align-items-center mb-2 p-3"
          style={{
            backgroundColor: "#ffffff",
            border: "2px solid #198754",
            borderRadius: "8px",
          }}
        >
          <span>
            <span style={{ display: "inline-block", minWidth: "30px" }}>
              ✔️
            </span>
            <strong style={{ color: "#2D083F" }}>In Basket:</strong>
          </span>
          <span>
            <span className="fs-6 fw-bold me-2" style={{ color: "#000000" }}>
              {stats[2]}
            </span>
            <small className="text-muted pl-1">
              ({getPercentage(stats[2])}%)
            </small>
          </span>
        </div>
        <div
          className="d-flex justify-content-between align-items-center mb-2 p-3"
          style={{
            backgroundColor: "#ffffff",
            border: "2px solid #ffc107",
            borderRadius: "8px",
          }}
        >
          <span>
            <span style={{ display: "inline-block", minWidth: "30px" }}>
              ⛓️
            </span>
            <strong style={{ color: "#2D083F" }}>Metal Hit:</strong>
          </span>
          <span>
            <span className="fs-6 fw-bold me-2" style={{ color: "#000000" }}>
              {stats[1]}
            </span>
            <small className="text-muted pl-1">
              ({getPercentage(stats[1])}%)
            </small>
          </span>
        </div>
        <div
          className="d-flex justify-content-between align-items-center mb-3 p-3"
          style={{
            backgroundColor: "#ffffff",
            border: "2px solid #dc3545",
            borderRadius: "8px",
          }}
        >
          <span>
            <span style={{ display: "inline-block", minWidth: "30px" }}>
              🚫
            </span>
            <strong style={{ color: "#2D083F" }}>Miss:</strong>
          </span>
          <span>
            <span className="fs-6 fw-bold me-2" style={{ color: "#000000" }}>
              {stats[0]}
            </span>
            <small className="text-muted pl-1">
              ({getPercentage(stats[0])}%)
            </small>
          </span>
        </div>
        <div
          className="d-flex justify-content-between align-items-center pt-3 p-3"
          style={{
            borderTop: "2px solid #dee2e6",
            backgroundColor: "#ffffff",
            border: "2px solid #6c757d",
            borderRadius: "8px",
          }}
        >
          <strong style={{ color: "#2D083F" }}>Total Throws:</strong>
          <strong className="fs-5" style={{ color: "#000000" }}>
            {totalThrows}
          </strong>
        </div>
      </div>
    </div>
  );
}

export default AllTimeThrowScoreStats;
